/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { ChainDependencies } from './dependenciesChainClass.generated';
import { typedDependencies } from './dependenciesTyped.generated';
import { createChain } from '../../factoriesAny.js';
export var chainDependencies = {
  ChainDependencies: ChainDependencies,
  typedDependencies: typedDependencies,
  createChain: createChain
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesChain.generated.js
// module id = 1501
// module chunks = 0